import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterOption } from '../../../types';
import {
  ActiveOptionContainer,
  ActiveListWrapper,
  CancellButton,
} from './ModelFamilySelector.style';
import CancelIcon from '../../../assets/icons/CancelIcon';
import CheckboxSelector from '../../CheckboxComponent';
import { AvailableFiltersCount } from '../../../types/oneGraphTypes';

interface ActiveModelsProps {
  modelFamilyOptions: {
    [key: string]: AvailableFiltersCount;
  };
  selectedModelFamilyFilters: string[];
  filterType: string;
  onChange: (newValue: string) => void;
}

const ActiveModelFamiliesList: React.FC<ActiveModelsProps> = ({
  modelFamilyOptions,
  selectedModelFamilyFilters,
  filterType,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <ActiveListWrapper data-testid="active-model-families-group">
      {selectedModelFamilyFilters.map((item) => {
        const model = modelFamilyOptions[item];
        return (
          <ActiveOptionContainer key={`model-faimly-active-${model.value}`}>
            <CheckboxSelector
              inputName={`active-${model.value}`}
              onChange={() => onChange(model.value)}
              value={model.value}
              filterType={filterType}
              checked={selectedModelFamilyFilters.includes(model.value)}
              disabled={model.disabled}
            />
            <CancellButton
              aria-label={`remove ${model.id} from model families`}
              onClick={() => onChange(model.value)}
              data-testid={`remove-active-filter-icon-${model.value}`}
            >
              <CancelIcon />
            </CancellButton>
          </ActiveOptionContainer>
        );
      })}
    </ActiveListWrapper>
  );
};

export default ActiveModelFamiliesList;
